import React, {Component} from 'react'
import { connect } from "react-redux"
import store from "store";
import {createToast} from "actions";
import {textToast} from "app/helpers/toast_factory";
import {AxiosResponse} from "axios";
import trans from 'trans'

import {
    css,
    Theme,
    Button,
    Div,
    Spinner,
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import {
    getMergadoElements,
    saveProductElementsMap,
} from "app/helpers/api";


import { MergadoElementsType } from 'products/types'
import { setProjectToStore } from 'app/reducers/project'
import { Project } from 'app/types/model-types';
import { Autocomplete, Field, Icon, MUSProvider } from '@mus/core';

type Element = {
    value: string
    label: string
    hidden: boolean
    title: string
}

type NewMergadoData = {
    attributes: string
    elements: any
}

export type MergadoProduct = {
    id: number
    created_at: string
    data: object|any
    input_data?: object|any
    output_changed_at: string
    updated_at: string
}

interface Props {
    project: Project
    close?: Function
    projectLoaded: boolean
}

interface State {
    elements: any[]
    isLoading: boolean
    isSavingMap: boolean
    project: Project
}


class MapProductElements extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            elements: null,
            isLoading: false,
            isSavingMap: false,
            project: props.project,
        }
    }

    updateMap = (project: Project) => {
        this.setState({project: project})
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (this.props.projectLoaded && !prevProps.projectLoaded || (prevProps && JSON.stringify(prevProps.project) !== JSON.stringify(this.props.project))) {
            this.updateMap(this.props.project)
        }
    }

    componentWillUnmount() {
        if (typeof this.props.close === "undefined") {
            this.handleSave(false)
        }
    }

    componentDidMount() {
        this.getElementsFromApi()
    }

    getElementsFromApi = () => {
        this.setState({isLoading: true})
        getMergadoElements()
            .then((response: AxiosResponse<MergadoElementsType>) => {
                const mappedElements = response.data.map(i => ({
                    value: i,
                    label: i,
                    title: i,
                    hidden: false
                }))
                this.setState({elements: mappedElements})
            })
            .catch(error => {
                console.error(error)
                store.dispatch(createToast(textToast('error', error.response ?? '')))
            })
            .finally(() => {
                this.setState({isLoading: false})
            })
    }

    handleSave = (closeOnSave: boolean) => {
        const {project} = this.state

        saveProductElementsMap(project)
            .then((response: AxiosResponse<Project>) => {
                store.dispatch(setProjectToStore({...this.props.project, ...response.data}))
            })
            .catch(error => {
                console.error('cannot save map', error)
            })
            .finally(() => {
                if (closeOnSave) {
                    this.props.close()
                }
            })
    }

    /*randomProduct = () => this.setState({selectedProductIndex: Math.floor(Math.random() * 9)})*/

    render() {
        const {project, elements, isLoading} = this.state
        const { projectLoaded } = this.props

        if (!elements || !projectLoaded) {
            return <Div textAlign="center" padding="20px">
                <Spinner type="bubbles"/>
            </Div>
        }

        const isTheSame = project?.input_format === project?.output_format

        const inputFormatName = project && project.input_format && project.input_format.startsWith('custom.') ? project.name : project?.input_format
        const outputFormatName = project && project.output_format && project.output_format.startsWith('custom.') ? project.name : project?.output_format

        return <Style>
            <Grid cols={'1fr 1fr'} gap="20px">
                {!isTheSame ? RenderRow(elements, this.updateMap, 'e_img_url_input', project, inputFormatName) : null}
                {RenderRow(elements, this.updateMap, 'e_img_url', project, !isTheSame ? outputFormatName : null)}
                {!isTheSame ? RenderRow(elements, this.updateMap, 'e_alt_img_url_input', project, inputFormatName) : null}
                {RenderRow(elements, this.updateMap, 'e_alt_img_url', project)}
                {RenderRow(elements, this.updateMap, 'e_item_id', project)}
                {RenderRow(elements, this.updateMap, 'e_url', project)}
                {RenderRow(elements, this.updateMap, 'e_name', project)}
                {RenderRow(elements, this.updateMap, 'e_price_vat', project)}
            </Grid>
            {typeof this.props.close !== "undefined" &&
            <Div padding="20px" textAlign="center">
                <Button
                    icon="check-slim"
                    type={'void'}
                        onClick={() => {
                            this.handleSave(true)
                        }}
                    color={Theme.green}
                >{trans('save')}</Button>
            </Div>
            }
        </Style>
    }
}

const Style = css("div")({
    "table": {
        width: "100%"
    },
    ".first": {
        width: "40%",
    },
    ".ellipsis": {
        position: "relative",
    },
    ".ellipsis:before": {
        content: '"&nbsp;"',
        visibility: "hidden",
    },
    ".ellipsis span": {
        position: "absolute",
        left: 0,
        right: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    }

})

const RenderRow = (elements: Element[], updateMap: Function, rowName: string, project: Project, formatName = "") => {
    const inputValue = project[rowName] ?? ''

    return (
        <GridCell>
            <Field label={trans(`element_short_${rowName}`)} sublabel={<small>{trans(`element_${rowName}`) + `${formatName ? (" / " + formatName) : ""}`}</small>}>
                <Autocomplete
                    options={elements}
                    value={inputValue}
                    onChange={(value: string) => {
                        let updatedMap = { ...project }
                        updatedMap[rowName] = value
                        updateMap(updatedMap)
                        return value
                    }}
                />
            </Field>
        </GridCell>
    )
}

function mapStateToProps(state) {
    return {
        project: state.project.data,
        projectLoaded: state.project.isLoaded,
    }
}

export default connect(mapStateToProps, {})(MapProductElements)